import { computeRoutePdfLength } from "utils/computeRoutePdfLength";
import type { SetNodePositionInRoute } from "./types";

export const setNodePositionInRoute: SetNodePositionInRoute = ({
  geometry,
  nodeId,
  pos,
}) => {
  const updatedNodes = geometry.nodes.map((node) =>
    node.id === nodeId ? { ...node, x: pos.x, y: pos.y } : node,
  );
  const polylineLength = computeRoutePdfLength({
    nodes: updatedNodes,
    edges: geometry.edges,
  });
  return {
    nodes: updatedNodes,
    edges: geometry.edges,
    polylineLength,
  };
};
